export default "__VITE_ASSET__DFJa1FyH__"